import type { ComponentType } from "react";
import { useStore } from "lib/store/store";
import { tools } from "lib/data";
import type { Tool } from "lib/types";
import {
  TgBulkSenderPage,
  TgVideoDownloaderPage,
  TgTranslatorPage,
} from "components/tools/ToolSubscriptionPage";

const TOOL_SUBSCRIPTION_PAGES: Record<
  Tool,
  ComponentType<{ manageToolsEmbedded?: boolean }>
> = {
  tgb: TgBulkSenderPage,
  tgv: TgVideoDownloaderPage,
  tgt: TgTranslatorPage,
};

export default function ManageTools() {
  const { setPopupOpen, manageToolsActiveTool } = useStore();

  if (manageToolsActiveTool && manageToolsActiveTool in TOOL_SUBSCRIPTION_PAGES) {
    const Page = TOOL_SUBSCRIPTION_PAGES[manageToolsActiveTool as Tool];
    return (
      <div>
        <Page key={manageToolsActiveTool} manageToolsEmbedded />
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between border-b border-[var(--dash-border)] pb-3 mb-6">
        <h3 className="text-[var(--dash-text-strong)] font-semibold flex items-center gap-2 text-sm md:text-base">
          <i className="fas fa-sliders-h text-[var(--dash-text-muted)]"></i> Select Tool to Manage
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {tools.map((tool) => {
          return (
            <div
              id={tool.id}
              key={tool.id}
              className="bg-[var(--dash-surface)] border border-[var(--dash-border)] p-6 rounded-xl text-center shadow-[var(--dash-shadow)] transition-all hover:border-[var(--theme-accent)] hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-[color-mix(in_srgb,var(--theme-accent)_10%,transparent)] text-[var(--theme-accent)] rounded-full flex items-center justify-center text-2xl mx-auto mb-4">
                <img src={tool.image} alt={tool.name} width={35} />
              </div>
              <h4 className="text-[var(--dash-text-strong)] font-semibold mb-1">{tool.name}</h4>
              <p className="text-xs text-[var(--dash-text-muted)]">{tool.miniDes}</p>
              <button
                onClick={() => {
                  setPopupOpen(tool.id);
                }}
                className="w-full py-2.5 mt-4 bg-[var(--dash-input)] text-[var(--theme-accent)] border border-[var(--dash-border)] rounded-md font-semibold transition-colors hover:bg-[var(--theme-accent)] hover:text-white cursor-pointer"
              >
                Login & Manage
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
